import { render } from "./App.vue?vue&type=template&id=d564c8e0"
const script = {}

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_a1974c00fb1ee55830629d88cae9a65a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__